import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useFooterLinks, useBaseLinks } from '../../context/ExternalLink';
import LanguageSwitcher from '../LanguageSwitcher';

import TrustPilotIconFooter from './TrustPilotIconFooter';

import FooterSimplifiedSection from './components/FooterSimplifiedSection';
import FooterSimplifiedSeparator from './components/FooterSimplifiedSeparator';

import SpotahomeFooter from './SpotahomeFooter';
import LegalFooter from './LegalFooter';
import SupportFooter from './SupportFooter';
import SocialFooter from './SocialFooter';
import AppFooter from './AppFooter';

import CopyrightFooter from './CopyrightFooter';
import FooterSimplifiedBlock from './components/FooterSimplifiedBlock';

import styles from './FooterSimplified.module.scss';

const FooterSimplified = React.memo(({ apps, locales, showContactInfo }) => {
  const externalLinks = useFooterLinks();
  const localeLinks = useBaseLinks();

  const handleLocaleChange = locales.onChange;

  return (
    <footer>
      <section className={classNames(styles.footer, styles['footer--beige'])}>
        <FooterSimplifiedSection>
          <SpotahomeFooter {...externalLinks} />
          <FooterSimplifiedBlock>
            <SupportFooter
              {...externalLinks}
              showContactInfo={showContactInfo}
            />
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock>
            <LegalFooter {...externalLinks} />
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock className={styles.footer__external}>
            <>
              <AppFooter {...apps} />
              <TrustPilotIconFooter />
            </>
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock className={styles.footer__trustpilot}>
            <TrustPilotIconFooter />
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock className={styles.footer__app}>
            <AppFooter {...apps} />
          </FooterSimplifiedBlock>
        </FooterSimplifiedSection>
      </section>
      <section
        className={classNames(
          styles.footer__disclaimer,
          styles['footer--disclaimer__beige']
        )}
      >
        <FooterSimplifiedSeparator />
        <FooterSimplifiedSection>
          <CopyrightFooter />
          <div className={styles.footer__language}>
            <LanguageSwitcher
              theme="dark"
              onChange={handleLocaleChange}
              locales={locales.list || Object.keys(localeLinks)}
              current={locales.current}
            />
            <SocialFooter />
          </div>
        </FooterSimplifiedSection>
      </section>
    </footer>
  );
});

FooterSimplified.propTypes = {
  locales: PropTypes.shape({
    current: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.string),
    routes: PropTypes.objectOf(PropTypes.string),
    onChange: PropTypes.func.isRequired
  }).isRequired,
  apps: PropTypes.shape({
    android: PropTypes.object,
    ios: PropTypes.object
  }),
  showContactInfo: PropTypes.bool
};

FooterSimplified.defaultProps = {
  apps: {},
  showContactInfo: false
};

export default FooterSimplified;
